var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgOfferIcon = function SvgOfferIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 5.625V9.75C10.5 9.94891 10.421 10.1397 10.2803 10.2803C10.1397 10.421 9.94891 10.5 9.75 10.5H2.625C2.42609 10.5 2.23532 10.421 2.09467 10.2803C1.95402 10.1397 1.875 9.94891 1.875 9.75V5.625M6 2.4375C6 2.17791 5.92302 1.92415 5.7788 1.70831C5.63458 1.49248 5.4296 1.32425 5.18977 1.22491C4.94994 1.12557 4.68604 1.09958 4.43144 1.15022C4.17684 1.20086 3.94298 1.32587 3.75942 1.50942C3.57587 1.69298 3.45086 1.92684 3.40022 2.18144C3.34958 2.43604 3.37557 2.69994 3.47491 2.93977C3.57425 3.1796 3.74247 3.38458 3.95831 3.5288C4.17415 3.67302 4.42791 3.75 4.6875 3.75H6M6 2.4375V3.75M6 2.4375C6 2.17791 6.07698 1.92415 6.2212 1.70831C6.36542 1.49248 6.5704 1.32425 6.81023 1.22491C7.05006 1.12557 7.31396 1.09958 7.56856 1.15022C7.82316 1.20086 8.05702 1.32587 8.24058 1.50942C8.42413 1.69298 8.54914 1.92684 8.59978 2.18144C8.65042 2.43604 8.62443 2.69994 8.52509 2.93977C8.42575 3.1796 8.25753 3.38458 8.04169 3.5288C7.82585 3.67302 7.57209 3.75 7.3125 3.75H6M6 3.75V10.5M1.6875 5.625H10.6875C10.998 5.625 11.25 5.373 11.25 5.0625V4.3125C11.25 4.002 10.998 3.75 10.6875 3.75H1.6875C1.377 3.75 1.125 4.002 1.125 4.3125V5.0625C1.125 5.373 1.377 5.625 1.6875 5.625Z",
    stroke: "#8246FF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgOfferIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/offer-icon.114f26943fbcd4cc7785aee0360f8cc1.svg";